import { DOMAIN } from '../../../../../var_env.'
import { RequestResponsePattern } from '../../../../../types/Request'
import { getApi } from '../../../../../utils/requestApi'

export interface AnaliseAmostraTerceiraItem {
    id: number
    uuid: string
    nomesClientes: string
    resultado: string
    flagAtivo: number
    dtCadastro: string
    idUsuarioCadastro: number
    dtAlteracao: string | null
    idUsuarioAlteracao: number | null
    dtExclusao: string | null
    idUsuarioExclusao: number | null
    motivoExclusao: string | null
}

export default async function getAnaliseAmostraTerceira(): Promise<AnaliseAmostraTerceiraItem[]> {
    const endpoint = DOMAIN
    const params = `/AnaliseAmostraTerceira`

    const response: RequestResponsePattern<AnaliseAmostraTerceiraItem[]> = await getApi({
        endpoint,
        params
    })

    if (response) {
        if (!response.flagErro) {
            return response.listaResultados
        }
        throw new Error(response.listaMensagens[0])
    }

    return []
}

